let dropdownLoaded = false

const { getElement, getElements } = window.BAO.Utils
class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    if (dropdownLoaded) return

    window.BAO.sectionRenderer
      .fetch('header', `${window.Shopify.routes.root}?view=dropdown`)
      .then(res => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res.header)
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.['menu-dropdown-toggle']?.exists) {
      this.els?.['menu-dropdown-toggle']?.elements.forEach(menuToggleEl => {
        this.listeners.add(
          menuToggleEl,
          'click',
          this.handleToggleButtonClick.bind(this),
        )
      })
    }

    this.listeners.add(document, 'click', this.handleFocusIn.bind(this))

    this.listeners.add(document, 'keyup', this.handleEscapePress.bind(this))

    if (window.visualViewport) {
      this.listeners.add(
        window.visualViewport,
        'resize',
        this.updateSearchDropdownHeight.bind(this),
      )
    }
  }

  /**
   * Sizes the mobile search dropdown to fill from its top edge to the bottom of
   * the layout viewport, so the page never shows underneath it. The area the
   * visual viewport loses at the bottom (iOS keyboard or Safari toolbar) is
   * added as bottom padding, so the last results can scroll clear of it.
   *
   * @returns {void}
   */
  updateSearchDropdownHeight () {
    const visual = window.visualViewport
    const obscured = visual
      ? Math.max(window.innerHeight - visual.height - visual.offsetTop, 0)
      : 0

    this.searchContainers.forEach(container => {
      const dropdown = container.querySelector('.hd-Banner_Dropdown')
      if (!dropdown) return

      if (
        container.getAttribute('data-show-search-dropdown') !== 'true' ||
        !window.matchMedia('(max-width: 767px)').matches
      ) {
        dropdown.style.removeProperty('height')
        dropdown.style.removeProperty('padding-bottom')
        return
      }

      const { top } = dropdown.getBoundingClientRect()
      dropdown.style.boxSizing = 'border-box'
      dropdown.style.height = `${Math.max(window.innerHeight - top, 0)}px`
      dropdown.style.paddingBottom = `${obscured}px`
    })
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonClick (event) {
    const menuToggleEl = event.target
    const parentItemEl = menuToggleEl.closest(this.els?.item?.selector)
    if (!parentItemEl) return
    const menuDropdownEl = getElement(this.els?.['menu-dropdown']?.selector, {
      context: parentItemEl,
    })
    const isExpanded = menuDropdownEl.getAttribute('aria-expanded') === 'true'
    if (isExpanded) {
      menuToggleEl.removeAttribute('data-active')
      menuDropdownEl.removeAttribute('aria-expanded')
    } else {
      menuToggleEl.setAttribute('data-active', String(!isExpanded))
      menuDropdownEl.setAttribute('aria-expanded', String(!isExpanded))
    }
  }

  /**
   * @param {FocusInEvent} event
   *
   * @returns {void}
   */
  handleFocusIn (event) {
    event.target.id === 'header-search-mobile' ||
    event.target.id === 'header-search-desktop'
      ? this.searchContainers.forEach(container => {
        container.setAttribute('data-show-search-dropdown', 'true')
        this.scrollRevealer.setAttribute('search-open', '')
      })
      : this.searchContainers.forEach(container => {
        container.setAttribute('data-show-search-dropdown', 'false')
        this.scrollRevealer.removeAttribute('search-open')
      })

    this.updateSearchDropdownHeight()

    if (
      event.target.closest(this.localName) &&
      !event.target.closest('[aria-expanded="true"]')
    ) {
      /* This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element */
      this.closeDropdowns()
    }

    if (!event.target.closest(this.localName)) {
      /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
      this.closeDropdowns()
    }

    if (event.target.closest('.hd-Banner_SearchClose')) {
      /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
      this.closeDropdowns()
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return
    this.closeDropdowns()
  }

  /**
   * @returns {void}
   */
  closeDropdowns () {
    if (this.els?.['menu-dropdown-toggle']?.exists) {
      this.els?.['menu-dropdown-toggle']?.elements.forEach(menuDropdownEl => {
        menuDropdownEl.removeAttribute('data-active')
      })
    }

    if (this.els?.['menu-dropdown']?.exists) {
      this.els?.['menu-dropdown']?.elements.forEach(menuDropdownEl => {
        menuDropdownEl.removeAttribute('aria-expanded')
      })
    }
  }

  get searchContainers () {
    return getElements('.hd-Banner_Search')
  }

  get scrollRevealer () {
    return getElement('scroll-revealer')
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
